// extracted by mini-css-extract-plugin
export default {"scrollToTop":"ScrollToTop_scrollToTop__hvjm6","visible":"ScrollToTop_visible__2470j","light":"ScrollToTop_light__E7YT2"};